import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

  export const getCreditCardsBooking = createAsyncThunk('appCreditCardsBooking/getCreditCardsBooking', async (GetCCDetails) => {
      
    const response = await axios.post(' https://api.zasway.com:8443/Booking/GetTableSummaryCreditCardsBooking', GetCCDetails, {mode:'cors'})
     
      return response.data 
  })
  export const UpdateParamState = createAsyncThunk('appBookingValidation/UpdateParamState', async (formData) => {
          
    const response = formData
 
    return response
  })
  export const getCreditCardsBookingdetails = createAsyncThunk('appCreditCardsBooking/getCreditCardsBooking', async (GetCCDetails) => {
      
    const response = await axios.post(' https://api.zasway.com:8443/Booking/GetTableSummaryCreditCardsBooking', GetCCDetails, {mode:'cors'})
     
      return response.data 
  })
  export const GetEmails = createAsyncThunk('appPassenger/GetEmails', async (ClientId) => {
     
    const response = await axios.post(' https://api.zasway.com:8443/Booking/GetBookingEmailAddresses', ClientId, {mode:'cors'})
     
    return response.data
  })
  export const StripeKey = createAsyncThunk('appCardtransactions/StripeKey', async (GetCCDetails) => {
    const response = await axios.post(' https://api.zasway.com:8443/Configuration/GetStripeKeyLive', GetCCDetails, {mode:'cors'})
    return response.data 
  })
  export const getFinancialInfo = createAsyncThunk('appCreditCardsBooking/getFinancialInfo', async (GetCCDetails) => {
    const response = await axios.post(' https://api.zasway.com:8443/Passenger/GetTableSummaryFinancialInfo', GetCCDetails, {mode:'cors'})
      return response.data 
  })
   export const GetCCTotalAndRevenue = createAsyncThunk('appCreditCardsBooking/GetCCTotalAndRevenue', async (GetCCDetails) => {
     
    const response = await axios.post(' https://api.zasway.com:8443/Booking/GetCCBookingsTotalAndRevenue', GetCCDetails, {mode:'cors'})
     
      return response.data 
  })
  
  export const getFinancialInfoDetails = createAsyncThunk('appCreditCardsBooking/getFinancialInfoDetails', async (GetCCDetails) => {
    const response = await axios.post(' https://api.zasway.com:8443/Passenger/GetTableSummaryFinancialInfo', GetCCDetails, {mode:'cors'})
      return response.data 
  })

  export const getBookingExpense = createAsyncThunk('appDriver/getBookingExpense', async (GetExpenseList) => {
    const response = await axios.post(' https://api.zasway.com:8443/Booking/GetTableSummaryBookingExpense', GetExpenseList, {mode:'cors'})
      return response.data
  })
  
  export const getsessionid = createAsyncThunk('appDriver/getBookingExpense', async (GetExpenseList) => {
    const response = await axios.post(' https://api.zasway.com:8443/PaymentTransaction/CheckoutPayment', GetExpenseList, {mode:'cors'})
      return response.data
  })
  
  export const getFinancialInfotransaction = createAsyncThunk('appCreditCardsBooking/getFinancialInfotransaction', async (GetCCDetails) => {
    const response = await axios.post(' https://api.zasway.com:8443/Passenger/GetTableSummaryFinancialInfo', GetCCDetails, {mode:'cors'})
      return response.data 
  })

  export const getallpaymenttransactions = createAsyncThunk('appCreditCardsBooking/getallpaymenttransactions', async (GetCCDetails) => {
    
    const response = await axios.post(' https://api.zasway.com:8443/PaymentTransaction/AllPaymentTransactions', GetCCDetails, {mode:'cors'})
     
    return response.data 
  })
  export const getpaymentintentid = createAsyncThunk('appCreditCardsBooking/getpaymentintentid', async (GetCCDetails) => {
    
    const response = await axios.post(' https://api.zasway.com:8443/PaymentTransaction/StripePaymentTokenProvided', GetCCDetails, {mode:'cors'})
     
    return response.data 
  })
  export const GetCustomerCard = createAsyncThunk('appCreditCardsBooking/GetCustomerCard', async (GetCCDetails) => {
     
    const response = await axios.post(' https://api.zasway.com:8443/PaymentTransaction/GetCustomerCard', GetCCDetails, {mode:'cors'})
      
    return response.data 
  })
  export const getCustomerID = createAsyncThunk('appCreditCardsBooking/getCustomerID', async (GetCCDetails) => {
    
    const response = await axios.post(' https://api.zasway.com:8443/PaymentTransaction/GetCustomerID', GetCCDetails, {mode:'cors'})
     
    return response.data 
  })
  export const Payment = createAsyncThunk('appCreditCardsBooking/Payment', async (GetCCDetails) => {
    
    const response = await axios.post(' https://api.zasway.com:8443/PaymentTransaction/StripePayment', GetCCDetails, {mode:'cors'})
     
    return response.data 
  })
  
  export const AddPaymentTransaction = createAsyncThunk('appCreditCardsBooking/AddPaymentTransaction ', async (params) => {
    const response = await axios.post(' https://api.zasway.com:8443/PaymentTransaction/AddPaymentTransaction', params, { mode: 'cors' })
      return response.data
  })
  export const sendReceipt = createAsyncThunk('appPassenger/sendReceipt', async (ClientId) => {
      
    const response = await axios.post(' https://api.zasway.com:8443/BookingInvoice/SendReceiptEmailCard', ClientId, {mode:'cors'})
     
    return response.data
  })
  export const StripeAPI = createAsyncThunk('appCreditCardsBooking/StripeAPI ', async (params) => {
       
    const response = await axios.post(' https://api.zasway.com:8443/PaymentTransaction/StripePayment', params, { mode: 'cors' })
       
      return response.data
  })
   
  export const getCreditCardsBookings = createAsyncThunk('appCreditCardsBooking/getCreditCardsBookings', async (GetCCDetails) => {
     
    const response = await axios.post(' https://api.zasway.com:8443/Booking/GetTableSummaryCreditCardsBooking', GetCCDetails, {mode:'cors'})
     
      return {
        data: response.data
      }
  })

  export const GetPaymentStatus = createAsyncThunk('appCreditCardsBooking/GetPaymentStatus ', async (params) => {
    const response = await axios.post(' https://api.zasway.com:8443/PaymentTransaction/GetPaymentStatus', params, { mode: 'cors' })
      return response.data
  })
 
  export const getClientList = createAsyncThunk('appCreditCardsBooking/getClientList', async (params) => {
    const response = await axios.post(' https://api.zasway.com:8443/Common/GetPassengerList', params, { mode: 'cors' })
    
      return response.data
  })

  export const getClientListSecond = createAsyncThunk('appCreditCardsBooking/getClientListSecond', async (params) => {
    const response = await axios.post(' https://api.zasway.com:8443/Common/GetClientList', params, { mode: 'cors' })
      return response.data
  })

  export const WebBookerPayment = createAsyncThunk('appCreditCardsBooking/Payment', async (GetCCDetails) => {
    
    const response = await axios.post(' https://api.zasway.com:8443/PaymentTransaction/CreatePaymentIntent', GetCCDetails, {mode:'cors'})
     
    return response.data 
  })
  export const WebBookerGetCustomerCard = createAsyncThunk('appCreditCardsBooking/GetCustomerCard', async (GetCCDetails) => {
     
    const response = await axios.post(' https://api.zasway.com:8443/PaymentTransaction/GetWebBookerCustomerCard', GetCCDetails, {mode:'cors'})
      
    return response.data 
  })
  export const WebBookergetCustomerID = createAsyncThunk('appCreditCardsBooking/getCustomerID', async (GetCCDetails) => {
    
    const response = await axios.post(' https://api.zasway.com:8443/PaymentTransaction/GetWebBookerCustomerID', GetCCDetails, {mode:'cors'})
     
    return response.data 
  })
  export const GetClientSecret = createAsyncThunk('appCreditCardsBooking/getCustomerID', async (GetCCDetails) => {
       
    const response = await axios.post(' https://api.zasway.com:8443/PaymentTransaction/TestClientSecret', GetCCDetails, {mode:'cors'})
      
    return response.data 
  })

export const appCreditCardsBookingSlice = createSlice({
    name: 'appCreditCardsBooking',
    initialState: {
      data: [],
      allData: [],
      creditCardBookingData: [],
      FinanceInfoBookingData: [],
      TotalBookingsRevenue: [],
      FilterState: false
    },
    reducers: {},
    extraReducers: builder => {

      builder
      .addCase(getCreditCardsBookings.fulfilled, (state, action) => {
         
        state.creditCardBookingData = action.payload.data
      })
      .addCase(GetCCTotalAndRevenue.fulfilled, (state, action) => {
          
        state.TotalBookingsRevenue = action.payload
         
      })
      .addCase(UpdateParamState.fulfilled, (state, action) => {
         
        state.FilterState = action.payload.param
         
      })
     .addCase(getFinancialInfo.fulfilled, (state, action) => {
        state.FinanceInfoBookingData = action.payload
      })
    }
  })

export default appCreditCardsBookingSlice.reducer